// extracted by mini-css-extract-plugin
module.exports = {"change-requests":"ChangeRequests_change-requests__3RNJf","badge":"ChangeRequests_badge__1qHJQ"};